"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SVBFaqApiContextualSupport;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _index = require("../../../index");
var _reactRouterDom = require("react-router-dom");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Support Contextual mlecule
 * By Prashant Bhatt<pbhatt@svb.com> (www.svb.com)
 * Summary
 * This component renders the whole support contextual molecule
 */

/**
 * Custom props to Render our own specs
 * @param {props} props
 * @returns
 */
function SVBFaqApiContextualSupport(props) {
  const {
    title,
    children,
    filterOption,
    extraClasses,
    faqsData
  } = props;
  const [faqsItemsJson, setFaqsItems] = (0, _react.useState)([]);
  const [mounted, setMounted] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    setFaqsItems(faqsData);
    setMounted(true);
  }, []);
  if (!mounted) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }
  const finalClass = extraClasses ? extraClasses + ' contextual-support-faq-questions' : 'contextual-support-faq-questions';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("section", {
    id: "contextual-support-faq",
    className: "".concat(finalClass, " mt-4")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/_react.default.createElement("h2", null, title || 'Have Questions?'), /*#__PURE__*/_react.default.createElement(_index.SVBFaqContextualDropdown, {
    filterOption: filterOption,
    faqsItems: faqsItemsJson
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "contextual-support-contact-us text-end mt-2"
  }, children || "Still can't find what you're looking for?", !children && /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    className: "questionContact ps-1",
    to: "/contact"
  }, "Contact Us"))));
}
SVBFaqApiContextualSupport.propTypes = {
  title: _propTypes.default.string,
  filterOption: _propTypes.default.object.isRequired,
  faqsData: _propTypes.default.array.isRequired,
  children: _propTypes.default.node,
  extraClasses: _propTypes.default.string
};